import Loadable from 'components/Loadable';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

const StatusRekeningKuasa = Loadable(lazy(() => import('./index')));

export const routes: RouteObject[] = [
    {
        path: 'laporan/status-rekening-kuasa',
        element: <StatusRekeningKuasa />,
    },
];
